import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
    selector: 'svg-add-icon-svg',
    template:  `
    <div class="svg-container">
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 52.3 (67297) - http://www.bohemiancoding.com/sketch -->
    <defs>
        <path d="M11.8730323,0.216387097 C18.3812903,0.216387097 23.6976774,5.53470968 23.6976774,12.0425806 C23.6976774,18.5930323 18.3809032,23.9111148 11.8730323,23.8687742 C5.36322581,23.8687742 0.0468387097,18.5504516 0.0468387097,12.0425806 C0.0468387097,5.53277419 5.32258065,0.216387097 11.8730323,0.216387097 Z M11.8730323,22.464 C17.6144516,22.464 22.2944516,17.7855484 22.2944516,12.0425806 C22.2944516,6.30116129 17.616,1.62116129 11.8730323,1.62116129 C6.1316129,1.62116129 1.4516129,6.2996129 1.4516129,12.0425806 C1.4516129,17.784 6.13006452,22.464 11.8730323,22.464 Z M17.0202581,11.3620645 L17.0202941,11.3622194 C17.4028579,11.3622194 17.7430812,11.6600942 17.7430812,12.0426581 C17.7430812,12.4252219 17.4028541,12.7654452 17.0202941,12.7654452 L12.5957779,12.7654452 L12.5957779,17.2321548 C12.5957779,17.6147187 12.2555547,17.9549419 11.8729908,17.9549419 C11.490427,17.9549419 11.1502037,17.6147148 11.1502037,17.2321548 L11.1502037,12.8076387 L6.72568761,12.8076387 C6.34312374,12.8076387 6.00290052,12.4674155 6.00290052,12.0848516 C6.00290052,11.7022877 6.34312761,11.3620645 6.72568761,11.3620645 L11.1486554,11.3620645 L11.1501677,6.93754839 C11.1501677,6.55498452 11.490391,6.21476129 11.8729548,6.21476129 C12.2555187,6.21476129 12.5957419,6.55498839 12.5957419,6.93754839 L12.5957419,11.3620645 L17.0202581,11.3620645 Z" id="add-svg-icon"></path>
    </defs>
    <g id="Page-3" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="04_Icons/small/add">
            <mask id="mask-add-svg" fill="white">
                <use xlink:href="#add-svg-icon"></use>
            </mask>
            <use id="mask-add-svg" fill="#000000" fill-rule="nonzero" xlink:href="#add-svg-icon"></use>
            <g id="00_Basic/Colors/blue2" mask="url(#mask-add-svg)" [attr.fill]="color" fill-rule="evenodd">
                <polygon id="box" points="0 0 24 0 24 24 0 24"></polygon>
            </g>
        </g>
    </g>
</svg>
    </div>`
})

export class AddIconSVGComponent {
    @Input() color: string;
}